(function ($) {
  $('.product-gallery-wrapper').slick({
    dots: true,
    arrows: true,
    autoplay: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    adaptiveHeight: true,
  });
})(jQuery);

const product_feature_gallery = document.querySelector('.product-gallery-wrapper');
if (product_feature_gallery) {
  const slick_dots = product_feature_gallery.querySelector('.slick-dots'); // Get the dots
  if (slick_dots) {
    const slick_dots_half_width = slick_dots.offsetWidth / 2;
    product_feature_gallery.style.setProperty('--slick-dots-half-width', slick_dots_half_width + 'px');
  }
}

// Size box popup
const kb_single_product_banner = document.querySelector('.kb-single-product-banner');
if (kb_single_product_banner) {
  const size_guide_btn = kb_single_product_banner.querySelector('.size-guide-btn');
  const guide_close_btn = kb_single_product_banner.querySelector('.guide-close-btn');

  if (size_guide_btn) {
    size_guide_btn.addEventListener('click', () => {
      kb_single_product_banner.classList.add('size-guide-box-active'); // Add 'active' class
    });
  }

  if (guide_close_btn) {
    guide_close_btn.addEventListener('click', () => {
      kb_single_product_banner.classList.remove('size-guide-box-active'); // Remove 'active' class
    });
  }
}
